/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onUpdateHub = /* GraphQL */ `subscription OnUpdateHub {
  onUpdateHub {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHubSubscriptionVariables,
  APITypes.OnUpdateHubSubscription
>;
export const onUpdateMission = /* GraphQL */ `subscription OnUpdateMission($id: ID!) {
  onUpdateMission(id: $id) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMissionSubscriptionVariables,
  APITypes.OnUpdateMissionSubscription
>;
export const onUpdateVehicle = /* GraphQL */ `subscription OnUpdateVehicle {
  onUpdateVehicle {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleSubscriptionVariables,
  APITypes.OnUpdateVehicleSubscription
>;
export const onUpdateVehicleByVin = /* GraphQL */ `subscription OnUpdateVehicleByVin($vin: String!) {
  onUpdateVehicleByVin(vin: $vin) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      sentAt
      severity
      relatedDeviations
      resolvedAt
      state
    }
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      updatedAt
      startedAt
      value
      triggerBy
      mrmExecutionPhase
      mrmType
      causes {
        deviationId
      }
      error
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    driverMode
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleByVinSubscriptionVariables,
  APITypes.OnUpdateVehicleByVinSubscription
>;
export const onUpdateVideoStreamingError = /* GraphQL */ `subscription OnUpdateVideoStreamingError($cameraID: String, $vin: String!) {
  onUpdateVideoStreamingError(cameraID: $cameraID, vin: $vin) {
    cameraID
    errorCode
    errorMessage
    vin
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVideoStreamingErrorSubscriptionVariables,
  APITypes.OnUpdateVideoStreamingErrorSubscription
>;
export const onUpdateMissionV2 = /* GraphQL */ `subscription OnUpdateMissionV2($id: ID!) {
  onUpdateMissionV2(id: $id) {
    id
    vin
    timestamp
    version
    actualArrivalTime
    actualStartTime
    description
    events {
      createdAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      type
    }
    fleetId
    name
    plannedArrivalTime
    progressDetails {
      ttl
      value {
        eta
        remainingDistanceInMeters
        traveledDistanceInMeters
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      positions {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMissionV2SubscriptionVariables,
  APITypes.OnUpdateMissionV2Subscription
>;
export const onUpdateVehicleV2 = /* GraphQL */ `subscription OnUpdateVehicleV2 {
  onUpdateVehicleV2 {
    vin
    timestamp
    activeMissionId {
      ttl
      value {
        data
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    adsState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    connectivityStatus {
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    deviations {
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          sentAt
          severity
          relatedDeviations
          resolvedAt
          state
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    driverMode {
      ttl
      value {
        mode
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    drivingState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      ttl
      value {
        data {
          value
          executionPhase
          causes
          startedAt
          triggerBy
          mrmType
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    speedMs {
      ttl
      value {
        speedMs
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleV2SubscriptionVariables,
  APITypes.OnUpdateVehicleV2Subscription
>;
export const onUpdateVehicleByVINV2 = /* GraphQL */ `subscription OnUpdateVehicleByVINV2($vin: String!) {
  onUpdateVehicleByVINV2(vin: $vin) {
    vin
    timestamp
    activeMissionId {
      ttl
      value {
        data
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    adsState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    connectivityStatus {
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    deviations {
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          sentAt
          severity
          relatedDeviations
          resolvedAt
          state
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    driverMode {
      ttl
      value {
        mode
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    drivingState {
      ttl
      value {
        state
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      ttl
      value {
        data {
          value
          executionPhase
          causes
          startedAt
          triggerBy
          mrmType
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
    speedMs {
      ttl
      value {
        speedMs
        updatedAt
      }
      error {
        type
        raisedAt
      }
    }
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleByVINV2SubscriptionVariables,
  APITypes.OnUpdateVehicleByVINV2Subscription
>;
export const onUpdateActiveMissionByVin = /* GraphQL */ `subscription OnUpdateActiveMissionByVin($vin: String!) {
  onUpdateActiveMissionByVin(vin: $vin) {
    vin
    fleetId
    payload {
      ... on MissionV2 {
        id
        vin
        timestamp
        version
        actualArrivalTime
        actualStartTime
        description
        events {
          createdAt
          position {
            altitude
            heading
            latitude
            longitude
          }
          type
        }
        fleetId
        name
        plannedArrivalTime
        progressDetails {
          ttl
          value {
            eta
            remainingDistanceInMeters
            traveledDistanceInMeters
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
        route {
          createdAt
          durationInSeconds
          externalRouteId
          landingHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          launchHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          predefinedRouteId
          totalDistanceInMeters
          updatedAt
          positions {
            altitude
            heading
            latitude
            longitude
          }
        }
        state {
          ttl
          value {
            state
            updatedAt
          }
          error {
            type
            raisedAt
          }
        }
      }
      ... on MissionUnassigned {
        vin
        timestamp
        version
        fleetId
      }
    }
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateActiveMissionByVinSubscriptionVariables,
  APITypes.OnUpdateActiveMissionByVinSubscription
>;
